const state = {
	allMcrItem: [],
	setErrorValidCat: [],
	selectedMcrItem: null
};

const mutations = {
  setAllMcrItem(state, allMcrItem) {
    state.allMcrItem = [...allMcrItem];
  },
  setSelectedMcrItem(state, item) {
    state.selectedMcrItem = item;
  },
	setAddItemMcrInCertObj(state, { idSelectedMcr, objectName, index, dataAdded }) {
    const targetItem = state.allMcrItem.find(w => w.id === idSelectedMcr);
    if (targetItem) {
      if (!targetItem[objectName]) {
        targetItem[objectName] = [];
      }
      targetItem[objectName].splice(index, 0, dataAdded);
    }
  },
	setDeleteItemMcrInCertObj(state, { idSelectedMcr, objectName, index }) {
		const targetCertMrp = state.allMcrItem.find(w => w.id === idSelectedMcr);
		if (targetCertMrp) targetCertMrp[objectName].splice(index, 1);
	},
	setAddValidationErrorAllMcrItemCat(state, data) {
		state.setErrorValidCat = data;
	},
	setAddCertainRowInErrValidation(state, { idxMcrItem, subTab, indexRowTab }) {
		if (state.setErrorValidCat && state.setErrorValidCat[idxMcrItem] && state.setErrorValidCat[idxMcrItem][subTab]) {
			state.setErrorValidCat[idxMcrItem][subTab].splice(indexRowTab, 0, {})
			// console.log("setAddCertainRowInErrValidation mutations", JSON.stringify(state.setErrorValidCat), state.setErrorValidCat[idxMcrItem][subTab][indexRowTab])
		}
	},
	setDeleteErrorValidationAllMcrItemCat(state) {
		state.setErrorValidCat = {};
	},
	setDelCertErrVal(state, { formUsedFor, field, idxMcrItem, subTab, indexRowTab }) {
		if (formUsedFor == 'cataloguer') {
			if (idxMcrItem === undefined || state.setErrorValidCat.length === 0 ) return;
			if (subTab == "" && indexRowTab == null) {
				delete state.setErrorValidCat[idxMcrItem][field]; //menghapus objet di error validaiton mcr item
			} else if (field !== "") {
				delete state.setErrorValidCat[idxMcrItem][subTab][indexRowTab][field]; //menghapus value di array subTab error validaiton mcr item
			} else {
				state.setErrorValidCat[idxMcrItem][subTab].splice(indexRowTab, 1); //menghapus array di subTab error validaiton mcr item
			}
		}
		// console.log("setDelCertErrVal mutations", JSON.stringify(state.setErrorValidCat), "field", field, "idxMcrItem", idxMcrItem, "subTab", subTab, "indexRowTab", indexRowTab)
	}
};

const actions = {
	storeAllMcrItem({commit}, data) {
		commit("setAllMcrItem", data)
	},
	addItemMcrInCertObj({ commit }, { idSelectedMcr, objectName, index, dataAdded }) {
    commit("setAddItemMcrInCertObj", { idSelectedMcr, objectName, index, dataAdded })
  },
	deleteItemMcrInCertObj({ commit }, { idSelectedMcr, objectName, index }) {
		commit("setDeleteItemMcrInCertObj", { idSelectedMcr, objectName, index })
	},
	addValidationErrorAllMcrItemCat({ commit }, { data }) {
		commit("setAddValidationErrorAllMcrItemCat", data)
	},	
	addCertainRowInErrValidation({ commit }, { idxMcrItem, subTab, indexRowTab }) {
		commit("setAddCertainRowInErrValidation", { idxMcrItem, subTab, indexRowTab })
	},
	deleteErrorValidationAllMcrItemCat({ commit }) {
		commit("setDeleteErrorValidationAllMcrItemCat")
	},
	deleteCertainErrorValidation({ commit }, { formUsedFor, field, idxMcrItem, subTab, indexRowTab }) {
		commit("setDelCertErrVal", { formUsedFor, field, idxMcrItem, subTab, indexRowTab })
	},
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};